var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C10 3.80558 13.8056 0 18.5 0C23.1944 0 27 3.80558 27 8.5C27 13.1944 23.1944 17 18.5 17H1.5C0.671573 17 0 16.3284 0 15.5C0 14.6716 0.671573 14 1.5 14H18.5C21.5376 14 24 11.5376 24 8.5C24 5.46243 21.5376 3 18.5 3C15.4624 3 13 5.46243 13 8.5C13 9.32843 12.3284 10 11.5 10C10.6716 10 10 9.32843 10 8.5ZM27.098 16.9235C27.8214 14.0299 30.4212 12 33.4039 12H33.5C37.0899 12 40 14.9101 40 18.5C40 22.0899 37.0899 25 33.5 25H31.1973C31.7078 25.8825 32 26.9071 32 28C32 31.3137 29.3137 34 26 34C23.5778 34 21.3932 32.5436 20.4615 30.3077L20.3654 30.0769C20.0468 29.3122 20.4084 28.434 21.1731 28.1154C21.9378 27.7968 22.816 28.1584 23.1346 28.9231L23.2308 29.1538C23.6966 30.2718 24.7889 31 26 31C27.6569 31 29 29.6569 29 28C29 26.3431 27.6569 25 26 25H1.5C0.671573 25 0 24.3284 0 23.5C0 22.6716 0.671573 22 1.5 22H33.5C35.433 22 37 20.433 37 18.5C37 16.567 35.433 15 33.5 15H33.4039C31.7978 15 30.3979 16.093 30.0084 17.6511L29.9552 17.8638C29.7543 18.6675 28.9399 19.1561 28.1362 18.9552C27.3325 18.7543 26.8439 17.9399 27.0448 17.1362L27.098 16.9235Z",
    fill: "#9BCAEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.6e07ca90e15674c038f3c042ade74fba.svg";
export { ForwardRef as ReactComponent };